import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mx-auto my-3" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = { class: "row mx-auto my-3" }
const _hoisted_4 = { class: "col-sm-12 col-md-6" }
const _hoisted_5 = { class: "row mx-auto my-3" }
const _hoisted_6 = { class: "col-sm-12 col-md-6" }
const _hoisted_7 = { class: "row mx-auto my-3" }
const _hoisted_8 = { class: "col-sm-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_need_reviews = _resolveComponent("scenario-need-reviews")!
  const _component_tab = _resolveComponent("tab")!
  const _component_scenario_in_review = _resolveComponent("scenario-in-review")!
  const _component_scenario_edits = _resolveComponent("scenario-edits")!
  const _component_scenario_approved = _resolveComponent("scenario-approved")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tabs, {
      options: { useUrlFragment: false },
      "nav-class": "nav nav-pills m-3",
      "nav-item-class": "nav-item col-md-3 col-sm-12 text-center",
      "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
      "nav-item-link-active-class": "active"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-clipboard-list text-primary'></i></h4>",
          name: "Awaiting Review"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_scenario_need_reviews, {
                  scenario_need_reviews: _ctx.scenario_need_reviews,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_need_reviews", "visit_loading"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-eye text-primary'></i></h4>",
          name: "Under My Review"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_scenario_in_review, {
                  scenario_in_review: _ctx.scenario_in_review,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_in_review", "visit_loading"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-i-cursor text-primary'></i></h4>",
          name: "Edits"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_scenario_edits, {
                  scenario_edits: _ctx.scenario_edits,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_edits", "visit_loading"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_tab, {
          prefix: "<h2 class='mt-2'>",
          suffix: " / <i class='fas fa-check-circle text-primary'></i></h4>",
          name: "Approved"
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_scenario_approved, {
                  scenario_approved: _ctx.scenario_approved,
                  visit_loading: _ctx.visit_loading
                }, null, 8, ["scenario_approved", "visit_loading"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}